import { render, staticRenderFns } from "./TrainDataListView.vue?vue&type=template&id=f4f66f2c&"
import script from "./TrainDataListView.vue?vue&type=script&lang=js&"
export * from "./TrainDataListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports